import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { interval, Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface Co2eBand {
  minValue: number;
  label: string;
  grade: string;
  color: string;
  angle: number;
}

@Component({
    selector: 'piranha-co2e-badge',
    templateUrl: './co2e-badge.component.html',
    styleUrls: ['./co2e-badge.component.scss'],
    standalone: false
})
export class Co2eBadgeComponent implements OnInit, OnChanges, OnDestroy {

  @Input() value: number;
  displayValue: number;

  band: Co2eBand;
  destroy$ = new Subject();
  stop$ = new Subject();

  constructor() { }

  ngOnInit(): void {
    
  }

  ngOnDestroy() {
    this.stop$.next();
    this.stop$.unsubscribe();
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.value) {
      this.calculate(changes.value.previousValue, changes.value.currentValue);
    }
  }

  bands: Co2eBand[] = [{
    minValue: 0,
    label: "Very low",
    grade: "A",
    color: "very-low",
    angle: 0
  }, {
    minValue: 0.5,
    label: "Low",
    grade: "B",
    color: "low",
    angle: 0
  }, {
    minValue: 1,
    label: "Medium",
    grade: "C",
    color: "medium",
    angle: 0
  }, {
    minValue: 1.5,
    label: "High",
    grade: "D",
    color: "high",
    angle: 0
  }, {
    minValue: 2,
    label: "Very high",
    grade: "E",
    color: "very-high",
    angle: 0
  }];

  calculate(oldValue: number, newValue: number) {

    // cap the values
    oldValue = oldValue || 0;
    oldValue = Math.min(oldValue, 999.99);
    newValue = Math.min(newValue, 999.99);
    this.displayValue = oldValue || 0;

    this.band = this.bands[0];
    this.bands.forEach(x => {
      if (newValue > x.minValue) this.band = x;
    });
    this.stop$.next();

    const diff = (newValue - oldValue) / 10;
    interval(50)
      .pipe(takeUntil(this.stop$))
      .subscribe(e => {
        this.displayValue += diff;
        if (e === 9) this.stop$.next();
      });

  }

  randomise() {
    const newValue = Math.random() * 3;
    this.calculate(this.value, newValue);
  }

}
